import config from '../../../../config'

import {
    REPORT_ACCESS_RIGHTS_REQUEST,
    REPORT_GET_TOKEN_REQUEST,
    REPORT_ENTITY_UPDATE,
    OPEN_REPORT_BY_ID,
    CLOSE_REPORT_BY_ID,
    SET_REPORT_MODULE_ACCESS_RIGHTS,
    REPORT_REMOVE,
} from './constants'

const MODULE_KEY = config.modules.report.key

export function openReportById(id) {
    return {
        type: OPEN_REPORT_BY_ID,
        data: {
            id,
        },
    }
}

export function closeReportById(id, fromTab = false) {
    return {
        type: CLOSE_REPORT_BY_ID,
        data: {
            id,
            fromTab,
        },
    }
}

export function reportAccessRightsRequest() {
    return {
        type: REPORT_ACCESS_RIGHTS_REQUEST,
        payload: {
            ...config.api.reportAccessRights,
            qs: {
                version: 'v3',
            },
        },
    }
}

export function reportGetTokenRequest(entityId, sessionId, locale) {
    return {
        type: REPORT_GET_TOKEN_REQUEST(entityId),
        payload: {
            ...config.api.realEstatesGetToken,
            uriParams: {
                entId: entityId, // eslint-disable-line camelcase
            },
            qs: {
                lang: locale,
                scope: MODULE_KEY,
            },
            headers: {
                sid: sessionId,
            },
        },
    }
}

export function reportEntityUpdate(entityId, updates) {
    return {
        type: REPORT_ENTITY_UPDATE(entityId),
        data: {
            entityId,
            updates,
        },
    }
}

export function setReportModuleAccessRights(accessRights) {
    return {
        type: SET_REPORT_MODULE_ACCESS_RIGHTS,
        data: {
            accessRights,
        },
    }
}

export function removeReportById(entityId) {
    return {
        type: REPORT_REMOVE,
        data: {
            entityId,
        },
    }
}
